export default {
  items: [
    // {
    //   id: "navigation",
    //   title: "Navigation",
    //   type: "group",
    //   icon: "icon-navigation",
    //   children: [
    //     {
    //       id: "dashboard",
    //       title: "Dashboard",
    //       type: "item",
    //       url: "/Dashboard/Dashboard",
    //       icon: "ic-home",
    //     },
    //   ],
    // },

    //모달있는 메뉴
    // test

    {
      id: "ui-element-dashboard",
      title: "UI ELEMENT",
      type: "group",
      icon: "icon-ui",
      children: [
        {
          id: "Dashboard",
          title: "Dashboard",
          type: "collapse",
          icon: "",
          url: "/Dashboard/Dashboard",
          children: [],
        },
      ],
    },
    {
      id: "ui-element-manage-users",
      title: "UI ELEMENT",
      type: "group",
      icon: "icon-ui",
      children: [
        {
          id: "UserList",
          title: "Manage Users",
          type: "collapse",
          icon: "",
          url: "/Manage_Users/UserList",
          children: [],
        },
      ],
    },
    // {
    //   id: "navigation",
    //   title: "Navigation",
    //   type: "group",
    //   icon: "icon-navigation",
    //   children: [
    //     {
    //       id: "Manage_Push_Notifications",
    //       title: "Manage Push Notifications",
    //       type: "item",
    //       url: "/Manage_Push_Notifications/ManagePushNotifications",
    //       icon: "ic-bell",
    //     },
    //   ],
    // },
    {
      id: "ui-element-Manage-Push-Notifications",
      title: "UI ELEMENT",
      type: "group",
      icon: "icon-ui",
      children: [
        {
          id: "Manage_Push_Notifications",
          title: "Manage\nPush Notifications",
          type: "collapse",
          icon: "",
          url: "/Manage_Push_Notifications/ManagePushNotifications",
          children: [],
        },
      ],
    },
    {
      id: "ui-element-Manage-Payments",
      title: "UI ELEMENT",
      type: "group",
      icon: "icon-ui",
      children: [
        {
          id: "Manage_Payments",
          title: "Manage Payments",
          type: "collapse",
          icon: "",
          url: "/Manage_Payments/ManagePaymentMaster/#!",
          children: [
            {
              id: "Payments",
              title: "- Manage Payments Master",
              type: "item",
              url: "/Manage_Payments/ManagePaymentMaster",
            },
            {
              id: "PaymentMaster",
              title: "- Manage Payments",
              type: "item",
              url: "/Manage_Payments/ManagePayments",
            },
          ],
        },
      ],
    },
    {
      id: "ui-element-Manage-Points",
      title: "UI ELEMENT",
      type: "group",
      icon: "icon-ui",
      children: [
        {
          id: "Manage_Points",
          title: "Manage Points",
          type: "collapse",
          icon: "",
          url: "/Manage_Points/Points/#!",
          children: [
            {
              id: "Points",
              title: "- Points",
              type: "item",
              url: "/Manage_Points/Points",
            },
            {
              id: "Cards",
              title: "- Debt/Credit card",
              type: "item",
              url: "/Manage_Points/Cards",
            },
            {
              id: "GiftCard",
              title: "- GiftCard",
              type: "item",
              url: "/Manage_Points/GiftCard",
            },
            {
              id: "Accounttransfer",
              title: "- Account transfer",
              type: "item",
              url: "/Manage_Points/Accounttransfer",
            },
          ],
        },
      ],
    },
    {
      id: "ui-element-Manage_Refund_request",
      title: "UI ELEMENT",
      type: "group",
      icon: "icon-ui",
      children: [
        {
          id: "Manage_Refund_request",
          title: "Manage\nRefund Request",
          type: "collapse",
          icon: "",
          url: "/Manage_Refund_request/ManageRefundrequest",
          children: [],
        },
      ],
    },
    {
      id: "ui-element-Customer-Support",
      title: "UI ELEMENT",
      type: "group",
      icon: "ic-help",
      children: [
        {
          id: "Customer_Support",
          title: "Customer Support",
          type: "collapse",
          icon: "",
          url: "/Customer_Support/Notice/#!",
          children: [
            {
              id: "Notice",
              title: "- Notice",
              type: "item",
              url: "/Customer_Support/Notice",
            },
            {
              id: "Question",
              title: "- 1:1 Question",
              type: "item",
              url: "/Customer_Support/Question",
            },
            {
              id: "FAQ",
              title: "- FAQ",
              type: "item",
              url: "/Customer_Support/FAQ",
            },
          ],
        },
      ],
    },
    {
      id: "ui-element-Terms-Privacy",
      title: "UI ELEMENT",
      type: "group",
      icon: "ic-invoice",
      children: [
        {
          id: "Terms_Privacy",
          title: "Terms / Privacy",
          type: "collapse",
          icon: "",
          url: "/Terms_Privacy/Terms_of_Service/#!",
          children: [
            {
              id: "Terms_Privacy_Terms_of_Service",
              title: "- Terms of Service",
              type: "item",
              url: "/Terms_Privacy/Terms_of_Service",
            },
            {
              id: "Terms_Privacy_Personal_Info_Collection_Usage",
              title: (
                <span>
                  - Personal Information <br /> Collection and Usage
                </span>
              ),
              type: "item",
              url: "/Terms_Privacy/Personal_Info_Collection_Usage",
            },
          ],
        },
      ],
    },
    {
      id: "ui-element-Manage-Administrator",
      title: "UI ELEMENT",
      type: "group",
      icon: "ic-setting",
      children: [
        {
          id: "Manage_Administrator",
          title: "Manage Administrator",
          type: "collapse",
          icon: "",
          url: "/Manage_Administrator/Administrator_List/#!",
          children: [
            {
              id: "Manage_Administrator_Administrator_List",
              title: "- Administrator List",
              type: "item",
              url: "/Manage_Administrator/Administrator_List",
            },
            {
              id: "Manage_Administrator_Manage_Group",
              title: "- Manage Group",
              type: "item",
              url: "/Manage_Administrator/Manage_Group",
            },
          ],
        },
      ],
    },
    {
      id: "ui-element-Report",
      title: "UI ELEMENT",
      type: "group",
      icon: "ic-setting",
      children: [
        {
          id: "Report",
          title: "Manage Report",
          type: "collapse",
          icon: "",
          url: "/Report/AngkoPayUserReportsList/#!",
          children: [
            {
              id: "User_Report_Chat_list",
              title: "- AngkorChat Report User List",
              type: "item",
              url: "/Report/AngkoPayUserReportsList",
            },
          ],
        },
      ],
    },

    {
      id: "ui-element-Common-code",
      title: "UI ELEMENT",
      type: "group",
      icon: "ic-setting",
      children: [
        {
          id: "Common_code",
          title: "Common Code",
          type: "collapse",
          icon: "",
          url: "/Common_code/Common_code/#!",
          children: [],
        },
      ],
    },

    {
      id: "ui-element-Manage-Menu",
      title: "UI ELEMENT",
      type: "group",
      icon: "ic-setting",
      children: [
        {
          id: "Manage_Menu",
          title: "Manage Menu",
          type: "collapse",
          icon: "",
          url: "/Manage_Menu/ManageMenu/#!",
          children: [],
        },
      ],
    },

    // {
    //   id: "navigation",
    //   title: "Navigation",
    //   type: "group",
    //   icon: "icon-navigation",
    //   children: [
    //     {
    //       id: "Manage_Withdrawal_Requests",
    //       title: "Manage Withdrawal Requests",
    //       type: "item",
    //       url: "/Manage_Withdrawal_Requests/ManageWithdrawalRequests",
    //       icon: "ic-dollar-default",
    //     },
    //   ],
    // },
    // {
    //   id: "ui-element-Manage-Withdrawal-Requests",
    //   title: "UI ELEMENT",
    //   type: "group",
    //   icon: "icon-ui",
    //   children: [
    //     {
    //       id: "Manage_Withdrawal_Requests",
    //       title: "Manage\nWithdrawal Requests",
    //       type: "collapse",
    //       icon: "ic-dollar-default",
    //       url: "/Manage_Withdrawal_Requests/ManageWithdrawalRequests",
    //       children: [],
    //     },
    //   ],
    // },
    {
      id: "ui-element-Manage-Affiliates",
      title: "UI ELEMENT",
      type: "group",
      icon: "icon-ui",
      children: [
        {
          id: "Manage_Affiliates",
          title: "Manage Affiliates",
          type: "collapse",
          icon: "ic-affiliate-dafault",
          url: "/Manage_Affiliates/ManageAffiliates",
          children: [],
        },
      ],
    },

    {
      id: "chart-maps",
      title: "Chart & Maps",
      type: "group",
      icon: "icon-charts",
      children: [
        {
          id: "charts",
          title: "Charts",
          type: "item",
          icon: "",
          url: "/charts/nvd3",
        },
      ],
    },
  ],
};
